<template>
    <div class="setup">
        <public1></public1>
        <div class="setup-content right-content">
            <div class="perheader">
                <perheader></perheader>
            </div>
            <div class="table-content">
                <div class="above">
                    <div class="row">
                        <div class="row1">默认单价</div>
                        <div class="row2">{{price}}元</div>
                        <el-button class="row3" size="medium" type="primary" @click="PriceBox">修改</el-button>
                    </div>
                    <div class="row">
                        <div class="row1">默认透支额度</div>
                        <div class="row2">{{excess}}度</div>
                        <el-button class="row3" size="medium" type="primary" @click="ExcessBox">修改</el-button>
                    </div>
                    <div class="row">
                        <div class="row1">剩余电量预警</div>
                        <div class="row2">{{alarmvalue}}度</div>
                        <el-button class="row3" size="medium" type="primary" @click="AlarmBox">修改</el-button>
                    </div>
                    <div class="row">
                        <div class="row1">断电短信提醒</div>
                        <div class="row2">{{sms}}</div>
                        <el-button class="row3" size="medium" type="success" @click="SmsBox(1)" v-if="sms=='关闭'">开启</el-button>
                        <el-button class="row3" size="medium" type="info" @click="SmsBox(0)" v-if="sms=='开启'">关闭</el-button>
                    </div>


                </div>
            </div>


        </div>
    </div>
</template>

<script>
    import store from "../store";
    import public1 from '@/views/public1.vue'
    import perheader from '@/components/perheader.vue'
    export default {
        name: "setup",
        components: {
            public1,
            perheader,
        },
        data(){
            return {
                price:1,
                excess:0,
                alarmvalue:0,
                sms:'',
            }
        },
        mounted(){
            this.price=window.localStorage.price;
            this.excess=window.localStorage.excess/100;
            this.alarmvalue=window.localStorage.alarmvalue;
            if(window.localStorage.sms>0){
                this.sms="开启";
            }else{
                this.sms="关闭";
            }
        },
        methods:{
            PriceBox() {
                this.$prompt('请输入单价', '修改单价', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:  /^[0-9]+.?[0-9]*$/,
                    inputErrorMessage: '单价格式不正确'
                }).then(({ value }) => {
                    this.$http.put(`${store.state.url}user/param/price/`+value+`?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.price=value;
                                window.localStorage.price=value;
                                this.$message({
                                    type: 'success',
                                    message: '你的单价是: ' + value+'元'
                                });
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            ExcessBox() {
                this.$prompt('请输入透支额度', '修改透支额度', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:  /^[0-9]+.?[0-9]*$/,
                    inputErrorMessage: '格式不正确'
                }).then(({ value }) => {
                    this.$http.put(`${store.state.url}user/param/excess/`+value*100+`?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.excess=value;
                                window.localStorage.excess=value*100;
                                this.$message({
                                    type: 'success',
                                    message: '你的透支额度是: ' + value+'度'
                                });
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            AlarmBox() {
                this.$prompt('请输入剩余电量预警', '修改电量预警', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:  /^[0-9]+.?[0-9]*$/,
                    inputErrorMessage: '格式不正确'
                }).then(({ value }) => {
                    this.$http.put(`${store.state.url}user/param/alarmvalue/`+value*100+`?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                this.alarmvalue=value;
                                window.localStorage.alarmvalue=value*100;
                                this.$message({
                                    type: 'success',
                                    message: '你的剩余电量预警是: ' + value+'度'
                                });
                            } else {
                                this.$message(res.Message);
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            SmsBox(value) {
                if(value==1){
                    this.$confirm('确定开启断电短信提醒?', '短信功能', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        this.$http.put(`${store.state.url}user/param/sms/1?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                            .then((res) => {
                                if (res.Code == 0) {
                                    this.sms='开启';
                                    window.localStorage.sms='开启';
                                    this.$message({
                                        type: 'success',
                                        message: '断电短信提醒开启!'
                                    });
                                } else {
                                    this.$message(res.Message);
                                }
                            })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消操作'
                        });
                    });

                }else{
                    this.$confirm('确定关闭断电短信提醒?', '短信功能', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        this.$http.put(`${store.state.url}user/param/sms/0?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                            .then((res) => {
                                if (res.Code == 0) {
                                    this.sms='关闭';
                                    window.localStorage.sms='关闭';
                                    this.$message({
                                        type: 'success',
                                        message: '断电短信提醒关闭!'
                                    });
                                } else {
                                    this.$message(res.Message);
                                }
                            })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '取消操作'
                        });
                    });
                }
            },
        }
    }
</script>

<style scoped>
    .setup{
        height:100%;
    }
    .setup-content{
        margin: 4vh 3vw;
    }
    .table-content{
        width:90%;
        height:50%;
        border:1px solid #cecece;
        margin-top:5vh;
        margin-left:2%;
        display: flex;
        font-size: 16px;
        padding: 0.3rem;
        padding-top:1vh;
    }
    .above {
        /*height: 60%;*/
        width:100%;
    }
    .below{
        height: 40%;
        width:100%;
    }
    .row{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin:0.2rem auto;
    }
    .row1{
        width:20%;
    }
    .row2{
        width:20%;
    }
    .row3{
        width:8%;
    }


</style>
